/* Guys Formula page behaviour: menu, search, finder tabs, service page (gallery, options, sticky bar). */
(function () {
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  var html = document.documentElement;

  /* ---------- Focus trap for the menu and search panels ---------- */
  function trap(panel, e) {
    if (e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])', panel).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Menu drawer ---------- */
  var drawer = $('[data-gm-drawer]');
  var menuBtn = $('[data-gm-menu-open]');
  var lastFocus = null;
  function openMenu() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    html.classList.add('gm-lock');
    menuBtn.setAttribute('aria-expanded', 'true');
    var c = $('.gm-drawer__close', drawer); if (c) c.focus();
  }
  function closeMenu() {
    drawer.classList.remove('is-open');
    html.classList.remove('gm-lock');
    menuBtn.setAttribute('aria-expanded', 'false');
    setTimeout(function () { drawer.hidden = true; }, 260);
    if (lastFocus) lastFocus.focus();
  }
  if (drawer && menuBtn) {
    menuBtn.addEventListener('click', openMenu);
    $$('[data-gm-menu-close]', drawer).forEach(function (b) { b.addEventListener('click', closeMenu); });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); trap($('.gm-drawer__panel', drawer), e); });
    $$('a', drawer).forEach(function (a) { a.addEventListener('click', function () { if (a.getAttribute('href').charAt(0) === '#') closeMenu(); }); });
  }

  /* ---------- Search (predictive results from Shopify) ---------- */
  var search = $('[data-gm-search]');
  var searchBtn = $('[data-gm-search-open]');
  if (search && searchBtn) {
    var input = $('[data-gm-search-input]', search);
    var results = $('[data-gm-search-results]', search);
    var start = $('[data-gm-search-start]', search);
    var timer = null, lastQ = '';
    var openSearch = function () {
      lastFocus = document.activeElement;
      search.hidden = false; html.classList.add('gm-lock');
      searchBtn.setAttribute('aria-expanded', 'true');
      setTimeout(function () { input.focus(); }, 30);
    };
    var closeSearch = function () {
      search.hidden = true; html.classList.remove('gm-lock');
      searchBtn.setAttribute('aria-expanded', 'false');
      if (lastFocus) lastFocus.focus();
    };
    searchBtn.addEventListener('click', openSearch);
    $$('[data-gm-search-open-link]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openSearch(); }); });
    $('[data-gm-search-close]', search).addEventListener('click', closeSearch);
    search.addEventListener('click', function (e) { if (e.target === search) closeSearch(); });
    search.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); trap($('.gm-search__panel', search), e); });
    var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };
    var money = function (cents) { var n = Number(cents); if (String(cents).indexOf('.') > -1) n = Math.round(Number(cents) * 100); return 'AED ' + (n / 100).toLocaleString('en-US', { maximumFractionDigits: 2 }); };
    var run = function () {
      var q = input.value.trim();
      if (q === lastQ) return;
      lastQ = q;
      if (q.length < 2) { results.innerHTML = ''; start.hidden = false; return; }
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,tag,variants.sku,body')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (input.value.trim() !== q) return;
          var items = (data.resources && data.resources.results && data.resources.results.products) || [];
          start.hidden = items.length > 0;
          if (!items.length) { results.innerHTML = '<p class="gm-search__empty">No services match "' + esc(q) + '". Try a simpler word, like energy or heart.</p>'; return; }
          results.innerHTML = items.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '';
            var price = p.price_min && p.price_max && p.price_min !== p.price_max ? 'From ' + money(p.price_min) : money(p.price);
            return '<a class="gm-sresult" href="' + esc(p.url) + '"><span class="gm-sresult__img">' + img + '</span><span class="gm-sresult__text"><strong>' + esc(p.title) + '</strong><small>' + esc(p.type) + ' · ' + price + '</small></span></a>';
          }).join('') + '<a class="gm-sresult gm-sresult--all" href="/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q) + '">See all results</a>';
        })
        .catch(function () { results.innerHTML = ''; start.hidden = false; });
    };
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
  }

  /* ---------- Finder: three ways to browse ---------- */
  $$('[data-gm-finder]').forEach(function (root) {
    var tabs = $$('[data-gm-tab]', root);
    function selectTab(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { selectTab(tab); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (next) { e.preventDefault(); selectTab(next, true); }
      });
    });
    $$('[data-gm-group]', root).forEach(function (group) {
      var picks = $$('[data-gm-pick]', group);
      picks.forEach(function (pick) {
        pick.addEventListener('click', function () {
          picks.forEach(function (p) { p.setAttribute('aria-pressed', String(p === pick)); });
          var panel = null;
          $$('[data-gm-panel]', group).forEach(function (p) {
            var on = p.getAttribute('data-gm-panel') === pick.getAttribute('data-gm-pick');
            p.hidden = !on; if (on) panel = p;
          });
          if (panel) {
            var r = panel.getBoundingClientRect();
            if (r.top > window.innerHeight - 120 || r.top < 60) window.scrollTo({ top: r.top + window.scrollY - 80, behavior: 'smooth' });
            var rail = $('.gm-rail', panel); if (rail) rail.scrollLeft = 0;
          }
        });
      });
    });
  });

  /* ---------- Service page ---------- */
  var pform = $('[data-gm-product-form]');
  if (pform) {
    var variants = [];
    try { variants = JSON.parse($('[data-gm-variants]').textContent); } catch (e) {}
    var idInput = $('input[name="id"]', pform);
    var priceEls = $$('[data-gm-price]');
    var fmt = function (cents) { return 'AED ' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 2 }); };
    var qtyInput = $('[data-gm-qty-input]', pform);
    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];
    function paint() {
      var q = qtyInput ? Math.max(1, Number(qtyInput.value) || 1) : 1;
      priceEls.forEach(function (el) { el.textContent = fmt(current.price * (el.hasAttribute('data-gm-price-total') ? q : 1)); });
      $$('[data-gm-book-label]').forEach(function (el) { el.textContent = 'Book now · ' + fmt(current.price * q); });
      var nameEl = $('[data-gm-variant-name]'); if (nameEl) nameEl.textContent = variants.length > 1 ? current.title : '';
      var skuEl = $('[data-gm-sku]'); if (skuEl) skuEl.textContent = current.sku || '-';
    }
    $$('input[data-gm-option]', pform).forEach(function (r) {
      r.addEventListener('change', function () {
        var v = variants.filter(function (x) { return String(x.id) === r.value; })[0];
        if (v) { current = v; idInput.value = v.id; paint(); }
      });
    });
    if (qtyInput) {
      var minus = $('[data-gm-qty-step="-1"]', pform), plus = $('[data-gm-qty-step="1"]', pform);
      var setQ = function (n) { n = Math.min(10, Math.max(1, n)); qtyInput.value = n; minus.disabled = n <= 1; plus.disabled = n >= 10; paint(); };
      minus.addEventListener('click', function () { setQ(Number(qtyInput.value) - 1); });
      plus.addEventListener('click', function () { setQ(Number(qtyInput.value) + 1); });
      qtyInput.addEventListener('change', function () { setQ(Number(qtyInput.value) || 1); });
      setQ(Number(qtyInput.value) || 1);
    }
    paint();

    /* Age check: show a clear message next to the box instead of the browser bubble only. */
    var err = $('[data-gm-form-error]', pform);
    var ageBox = $('[data-gm-age]', pform);
    function checkForm() {
      var bad = pform.querySelector(':invalid');
      if (!bad) { if (err) err.hidden = true; if (ageBox) ageBox.classList.remove('is-invalid'); return true; }
      if (ageBox && ageBox.contains(bad)) { ageBox.classList.add('is-invalid'); }
      if (err) { err.textContent = ageBox && ageBox.contains(bad) ? 'Please tick the box to confirm you are 18 or over.' : 'Please complete the choices above.'; err.hidden = false; }
      (ageBox || bad).scrollIntoView({ block: 'center', behavior: 'smooth' });
      setTimeout(function () { try { bad.focus({ preventScroll: true }); } catch (e) {} }, 350);
      return false;
    }
    /* Without this script the browser's own checks apply. With it, show one clear message beside the box instead. */
    pform.noValidate = true;
    pform.addEventListener('invalid', function () { checkForm(); }, true);
    pform.addEventListener('submit', function (e) {
      if (!checkForm()) { e.preventDefault(); return; }
      $$('[data-gm-book-btn]').forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    });
    $$('[data-gm-sticky-book]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (!checkForm()) return;
        var mainBtn = $('button[type="submit"]', pform);
        if (pform.requestSubmit) pform.requestSubmit(mainBtn); else mainBtn.click();
      });
    });
    if (ageBox) ageBox.addEventListener('change', function () { ageBox.classList.remove('is-invalid'); if (err) err.hidden = true; });
    /* Back from the booking page with the browser button: let the buttons work again. */
    window.addEventListener('pageshow', function () { $$('[data-gm-book-btn]').forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; }); });

    /* Sticky bar: appears once the main Book button has scrolled away. */
    var sticky = $('[data-gm-sticky]');
    var main = $('[data-gm-main-book]');
    if (sticky && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var on = !en.isIntersecting;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', String(!on));
        $$('a, button', sticky).forEach(function (x) { x.tabIndex = on ? 0 : -1; });
      }).observe(main);
    }
  }

  /* ---------- Gallery dots ---------- */
  $$('[data-gm-gallery]').forEach(function (g) {
    var track = $('.gm-gallery__track', g), dots = $$('.gm-gallery__dots span', g), count = $('[data-gm-count-now]', g);
    if (!track || dots.length < 2) return;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
      if (count) count.textContent = i + 1;
    }, { passive: true });
  });

  /* ---------- Gentle section entrance (skipped when the phone asks for less motion) ---------- */
  if ('IntersectionObserver' in window && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var later = $$('.gm-main .gm-section').filter(function (el) { return el.getBoundingClientRect().top > window.innerHeight; });
    later.forEach(function (el) { el.classList.add('gm-reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    later.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Long descriptions: show more ---------- */
  $$('[data-gm-more]').forEach(function (box) {
    var desc = $('.gm-desc', box), btn = $('.gm-more__btn', box);
    if (!desc || !btn) return;
    if (desc.scrollHeight < 360) { btn.hidden = true; return; }
    box.classList.add('is-clamped');
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-clamped');
      btn.textContent = open ? 'Read more' : 'Show less';
      btn.setAttribute('aria-expanded', String(!open));
    });
  });
})();
